import React from 'react';

// React Icons
import { FaSync } from 'react-icons/fa';

const FullScreenLoader = () => {
  return (
    <div className="min-w-full min-h-screen flex justify-center items-center">
      <FaSync className="animate-spin-slow text-primary-500" size="3rem"></FaSync>
    </div>
  );
};

export default FullScreenLoader;
